import Utils from "../libs/Utils";
import {FIRST_CATEGORY_LEVEL} from "../utils/constants";

const getCategoryDescription = ({ "Niv_1-2_Seo": data }) => {
  const { htmlContent } = data;
  return htmlContent ?? null;
};

const getCategoryImage = (metaInfos) => {
  return Utils.getMetaInfosValueByCode("Image", metaInfos);
};

const getChildrenCategories = ({ childrenCategories, categoryLevel }) => {
  if (categoryLevel === FIRST_CATEGORY_LEVEL) {
    return childrenCategories.map((child) => ({
      id: child.id,
      label: child.label,
      link: Utils.getMetaInfosValueByCode("SeoUrl", child.metaInfos),
      items: child.childrenCategories.map((item) => ({
        id: item.id,
        label: item.label,
        link: Utils.getMetaInfosValueByCode("SeoUrl", item.metaInfos),
        image: Utils.getMetaInfosValueByCode("Image", item.metaInfos),
      })),
    }));
  } else {
    return childrenCategories.map((child) => ({
      id: child.id,
      label: child.label,
      link: Utils.getMetaInfosValueByCode("SeoUrl", child.metaInfos),
      image: Utils.getMetaInfosValueByCode("Image", child.metaInfos),
    }));
  }
};

const getHeaderCategory = ({
                             label,
                             relatedContents,
                             metaInfos,
                           }) => {
  return {
    label,
    description: getCategoryDescription(relatedContents),
    image: getCategoryImage(metaInfos),
  };
};

const getBlogCollection = ({ blogCollection }) => {
  return blogCollection.slice(0, 3).map(({ title, imageJpgUrl, url }) => ({
    title,
    url,
    image: imageJpgUrl,
  }));
};

const getCallToActionBlocks = ({ relatedContents }) => {
  const { "Niv_1-2_MiseEnAvant_BandeauBas": data } = relatedContents;
  return data?.htmlContent ?? null;
};

const getOurSelectionBlocks = ({ relatedContents }) => {
  const { "Niv2-Nos_Selections": data } = relatedContents;
  return data?.htmlContent ?? null;
};

const getOlapicBlocks = ({ mediaContentList }) => {
  const items = [];
  mediaContentList?.slice(0, 4).map(({ imageUrl, userName }) => {
    items.push({
      imageUrl: imageUrl,
      username: userName,
    });
  });
  return items;
};

export default (data) => {
  return [
    getHeaderCategory(data),
    getChildrenCategories(data),
    getBlogCollection(data),
    getOurSelectionBlocks(data),
    getCallToActionBlocks(data),
    getOlapicBlocks(data),
  ];
};
